import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import ProtectedRoutes from "./ProtectedRoutes";
import LoginPage from "../pages/login";
import HomePage from "../pages/home";
import OTPConfirmationPage from "../pages/otp";
import SignUpPage from "../pages/signUp";
import { useSelector } from "react-redux";
import TestPage from "../pages/test";
import TestBanner from "../pages/testBanner";
import StartTestPage from "../pages/startTest";
import MCQTestPage from "../pages/mcq";
import PerformanceTab from "../pages/performance";
import ViewSolution from "../pages/performance/viewSolution";

function RouteList() {
  const userSuccess = useSelector((state) => state.auth.user.success);

  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/login"
          element={userSuccess ? <Navigate to="/home" /> : <LoginPage />}
        />
        <Route path="/otp" element={<OTPConfirmationPage />} />
        <Route path="/sign-up" element={<SignUpPage />} />
        <Route element={<ProtectedRoutes />}>
          <Route path="/home" element={<HomePage />} />
          <Route path="/test/:id" element={<TestPage />} />
          <Route path="/performance/:id" element={<PerformanceTab />} />
          <Route path="/performance/:id/:parent" element={<PerformanceTab />} />
          <Route path="/view-solution/:id/:parent" element={<ViewSolution />} />
          <Route path="/test/:id/:parent" element={<TestPage />} />
          <Route path="/test-info/:id" element={<TestBanner />} />
          <Route path="/start-test/:id" element={<StartTestPage />} />
          <Route path="/mcq-test/:id" element={<MCQTestPage />} />
          <Route path="*" element={<Navigate to="/home" />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
export default RouteList;
